import { render, staticRenderFns } from "./Installment.vue?vue&type=template&id=06d28222&scoped=true"
import script from "./Installment.vue?vue&type=script&lang=js"
export * from "./Installment.vue?vue&type=script&lang=js"
import style0 from "./Installment.vue?vue&type=style&index=0&id=06d28222&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06d28222",
  null
  
)

export default component.exports